import {
  UserGroupClient,
  UserGroupDetailDTO,
  UserDTO,
  UserClient,
  AuthenticationClient,
  UserTypeDTO,
  UserOtpDTO,
  ResponseDTO,
  UserCredentialDTO,
} from 'business/models/Models';
import ModelFactory from 'business/models/ModelFactory';
import BaseService from './BaseService';

export default class UserGroupService extends BaseService {
  async saveUserGroupDetails(userGroup: UserGroupDetailDTO): Promise<any> {
    const client: UserGroupClient = ModelFactory(UserGroupClient);
    return await client.upsertUserGroup(userGroup);
  }

  async updatePassword(user: UserDTO): Promise<any> {
    const client: UserClient = ModelFactory(UserClient);

    try {
      return await client.updatePassword(user.id, user);
    } catch (e) {
      return e;
    }
  }

  async updateUser(user: UserDTO): Promise<UserDTO> {
    const client: UserClient = ModelFactory(UserClient);

    try {
      return await client.updateUser(user.id, user);
    } catch (e) {
      return e;
    }
  }

  async resetPassword(username: string): Promise<any> {
    const client: AuthenticationClient = ModelFactory(AuthenticationClient);

    try {
      return await client.resetPasswordRequest(username);
    } catch (e) {
      return e;
    }
  }

  async forgotPassword(username: string): Promise<any> {
    const client: AuthenticationClient = ModelFactory(AuthenticationClient);

    try {
      return await client.forgotPasswordRequest(username);
    } catch (e) {
      return e;
    }
  }

  async submitChangePassword(otpDetails: UserOtpDTO): Promise<ResponseDTO> {
    const client: AuthenticationClient = ModelFactory(AuthenticationClient);

    try {
      return await client.changePasswordRequest(otpDetails);
    } catch (e) {
      return e;
    }
  }

  async getUserTypes(): Promise<UserTypeDTO[]> {
    const client: UserClient = ModelFactory(UserClient, false, false);
    return await client.getUserTypes();
  }

  async validateAdminAndGenerateOTP(user: UserCredentialDTO) {
    const client: UserClient = ModelFactory(UserClient, false, false);
    return await client.generateUserOTP(user);
  }
}
